export const W = 960;
export const H = 540;
export const GROUND = 480;
export const DOOR_W = 44;
export const DOOR_H = 72;
export const STEP = 1000 / 60;

export const PHYS = { gravity: 0.55, jump: -12, speed: 4.2, accel: 0.9, friction: 0.78, maxFall: 14 };

export const PLATFORMS = [
  { x: 0, y: GROUND, w: W, h: H - GROUND, oneWay: false },
  { x: 400, y: 392, w: 160, h: 12, oneWay: true },
  { x: 40, y: 320, w: 250, h: 12, oneWay: true },
  { x: 670, y: 320, w: 250, h: 12, oneWay: true },
  { x: 340, y: 212, w: 280, h: 12, oneWay: true },
];

// y = bottom of door (surface it stands on)
export const DOORS = [
  { x: 70, y: GROUND },
  { x: 390, y: 212 },
  { x: 816, y: 320 },
  { x: 846, y: GROUND },
  { x: 526, y: 212 },
  { x: 100, y: 320 },
];

export const KEY = { x: 474, y: 60, w: 13, h: 20 };

export const SPAWN = { x: 468, y: GROUND - 34 };
